export default __webpack_public_path__ + "static/media/Megosu - KarTent - 2.5387f5c9.m4v";